var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect4, _rect5, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect7, _rect8, _rect9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect10, _rect11, _rect12, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayerFourLevels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 164,
    viewBox: "0 0 139 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 70C66.1801 67.7909 72.3838 67.7909 76.2102 70L131.636 102C135.462 104.209 135.462 107.791 131.636 110L76.2102 142C72.3838 144.209 66.1801 144.209 62.3538 142L6.92816 110C3.10182 107.791 3.10181 104.209 6.92815 102L62.3538 70Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 70C66.1801 67.7909 72.3838 67.7909 76.2102 70L131.636 102C135.462 104.209 135.462 107.791 131.636 110L76.2102 142C72.3838 144.209 66.1801 144.209 62.3538 142L6.92816 110C3.10182 107.791 3.10181 104.209 6.92815 102L62.3538 70Z",
    fill: "#6165FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 0.5 0 1 6.92822 110)",
    fill: "#BDACFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 142)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 142)",
    fill: "#8285F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05835 106C4.05835 107.562 5.15502 108.976 6.92811 110V130C5.15502 128.976 4.05835 127.562 4.05835 126V106Z",
    fill: "#BDACFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 142C66.1801 144.209 72.3838 144.209 76.2102 142V162C72.3838 164.209 66.1801 164.209 62.3538 162V142Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 142C66.1801 144.209 72.3838 144.209 76.2102 142V162C72.3838 164.209 66.1801 164.209 62.3538 162V142Z",
    fill: "#8285F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 106C134.505 107.562 133.409 108.976 131.636 110V130C133.409 128.976 134.505 127.562 134.505 126V106Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 106C134.505 107.562 133.409 108.976 131.636 110V130C133.409 128.976 134.505 127.562 134.505 126V106Z",
    fill: "#8285F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 48C66.1801 45.7909 72.3838 45.7909 76.2102 48L131.636 80C135.462 82.2091 135.462 85.7909 131.636 88L76.2102 120C72.3838 122.209 66.1801 122.209 62.3538 120L6.92816 88C3.10182 85.7909 3.10181 82.2091 6.92815 80L62.3538 48Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 48C66.1801 45.7909 72.3838 45.7909 76.2102 48L131.636 80C135.462 82.2091 135.462 85.7909 131.636 88L76.2102 120C72.3838 122.209 66.1801 122.209 62.3538 120L6.92816 88C3.10182 85.7909 3.10181 82.2091 6.92815 80L62.3538 48Z",
    fill: "#6165FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 0.5 0 1 6.92822 88)",
    fill: "#BDACFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 120)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 120)",
    fill: "#8285F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05835 84C4.05835 85.5621 5.15502 86.9763 6.92811 88V108C5.15502 106.976 4.05835 105.562 4.05835 104V84Z",
    fill: "#BDACFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 120C66.1801 122.209 72.3838 122.209 76.2102 120V140C72.3838 142.209 66.1801 142.209 62.3538 140V120Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 120C66.1801 122.209 72.3838 122.209 76.2102 120V140C72.3838 142.209 66.1801 142.209 62.3538 140V120Z",
    fill: "#8285F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 84C134.505 85.5621 133.409 86.9763 131.636 88V108C133.409 106.976 134.505 105.562 134.505 104V84Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 84C134.505 85.5621 133.409 86.9763 131.636 88V108C133.409 106.976 134.505 105.562 134.505 104V84Z",
    fill: "#8285F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 26C66.1801 23.7909 72.3838 23.7909 76.2102 26L131.636 58C135.462 60.2091 135.462 63.7909 131.636 66L76.2102 98C72.3838 100.209 66.1801 100.209 62.3538 98L6.92816 66C3.10182 63.7909 3.10181 60.2091 6.92815 58L62.3538 26Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 26C66.1801 23.7909 72.3838 23.7909 76.2102 26L131.636 58C135.462 60.2091 135.462 63.7909 131.636 66L76.2102 98C72.3838 100.209 66.1801 100.209 62.3538 98L6.92816 66C3.10182 63.7909 3.10181 60.2091 6.92815 58L62.3538 26Z",
    fill: "#6165FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 0.5 0 1 6.92822 66)",
    fill: "#BDACFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 98)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 98)",
    fill: "#8285F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05835 62C4.05835 63.5621 5.15502 64.9763 6.92811 66V86C5.15502 84.9763 4.05835 83.5621 4.05835 82V62Z",
    fill: "#BDACFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 98C66.1801 100.209 72.3838 100.209 76.2102 98V118C72.3838 120.209 66.1801 120.209 62.3538 118V98Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 98C66.1801 100.209 72.3838 100.209 76.2102 98V118C72.3838 120.209 66.1801 120.209 62.3538 118V98Z",
    fill: "#8285F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 62C134.505 63.5621 133.409 64.9763 131.636 66V86C133.409 84.9763 134.505 83.5621 134.505 82V62Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 62C134.505 63.5621 133.409 64.9763 131.636 66V86C133.409 84.9763 134.505 83.5621 134.505 82V62Z",
    fill: "#8285F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 4C66.1801 1.79086 72.3838 1.79086 76.2102 4L131.636 36C135.462 38.2091 135.462 41.7909 131.636 44L76.2102 76C72.3838 78.2091 66.1801 78.2091 62.3538 76L6.92816 44C3.10182 41.7909 3.10181 38.2091 6.92815 36L62.3538 4Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 4C66.1801 1.79086 72.3838 1.79086 76.2102 4L131.636 36C135.462 38.2091 135.462 41.7909 131.636 44L76.2102 76C72.3838 78.2091 66.1801 78.2091 62.3538 76L6.92816 44C3.10182 41.7909 3.10181 38.2091 6.92815 36L62.3538 4Z",
    fill: "#6165FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 0.5 0 1 6.92822 44)",
    fill: "#BDACFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 76)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    transform: "matrix(0.866025 -0.5 0 1 76.2102 76)",
    fill: "#8285F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05835 40C4.05835 41.5621 5.15502 42.9763 6.92811 44V64C5.15502 62.9763 4.05835 61.5621 4.05835 60V40Z",
    fill: "#BDACFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 76C66.1801 78.2091 72.3838 78.2091 76.2102 76V96C72.3838 98.2091 66.1801 98.2091 62.3538 96V76Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3538 76C66.1801 78.2091 72.3838 78.2091 76.2102 76V96C72.3838 98.2091 66.1801 98.2091 62.3538 96V76Z",
    fill: "#8285F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 40C134.505 41.5621 133.409 42.9763 131.636 44V64C133.409 62.9763 134.505 61.5621 134.505 60V40Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M134.505 40C134.505 41.5621 133.409 42.9763 131.636 44V64C133.409 62.9763 134.505 61.5621 134.505 60V40Z",
    fill: "#8285F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerFourLevels);
export default __webpack_public_path__ + "static/media/layer-four-levels.da553c3c6d578b9f2f45af9ef7c6fb15.svg";
export { ForwardRef as ReactComponent };